import React, { useEffect, useState } from 'react';
import { Button, Frame } from 'react95';
import packageInfo from '../../../../package.json';

const connectionSteps = [
  '正在拨号到 1995 年……',
  '正在寻找遗失的更新软盘……💾',
  '正在与未来协商兼容性……'
];

const updateResults = [
  {
    title: '你已拥有最好的昨天 ✨',
    description: '当前怀旧版本已是最新。',
    note: '更新记录：保留所有值得留下的旧时光。'
  },
  {
    title: '未来补丁延期了 🌀',
    description: '时间旅行服务器遇到时差。',
    note: '更新记录：预计昨天发布，请明天再来。'
  },
  {
    title: '发现一份夏日补丁 🌤️',
    description: '内容：晚霞饱和度 +10%，烦恼音量 −20%。',
    note: '状态：已随这条消息送达。'
  },
  {
    title: '更新软盘正在路上 💾',
    description: '快递员还在寻找 A: 驱动器。',
    note: '更新记录：本次先送上一点耐心。'
  }
];

const checkTimeFormat = new Intl.DateTimeFormat('zh-CN', {
  timeZone: 'Asia/Shanghai',
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});

export default function UpdatesPanel() {
  const [running, setRunning] = useState(false);
  const [step, setStep] = useState(0);
  const [checks, setChecks] = useState(0);
  const [checkedAt, setCheckedAt] = useState(null);
  const result = checks ? updateResults[(checks - 1) % updateResults.length] : null;

  useEffect(() => {
    if (!running) return undefined;
    const timers = [
      setTimeout(() => setStep(1), 1000),
      setTimeout(() => setStep(2), 2000),
      setTimeout(() => {
        setCheckedAt(new Date());
        setChecks(count => count + 1);
        setRunning(false);
      }, 3000)
    ];
    return () => timers.forEach(clearTimeout);
  }, [running]);

  function checkUpdates() {
    setStep(0);
    setRunning(true);
  }

  return (
    <div className="system-extra-panel">
      <div className="system-panel-heading">
        <span className="system-channel" aria-hidden="true">04 / UPDATES</span>
        <h2>来自过去的更新 📡</h2>
        <p>连接昨天的服务器，看看明天有没有消息。</p>
      </div>
      <dl className="system-update-details">
        <div><dt>当前版本</dt><dd>{packageInfo.version}</dd></div>
        <div><dt>更新频道</dt><dd>永恒的 1995</dd></div>
        <div>
          <dt>上次检查</dt>
          <dd>{checkedAt ? <time dateTime={checkedAt.toISOString()}>{checkTimeFormat.format(checkedAt)}</time> : '尚未联系过去'}</dd>
        </div>
      </dl>
      <Frame variant="field" className="system-update-result" role="status" aria-label="更新状态" aria-live="polite" aria-atomic="true">
        {running ? (
          <p>{connectionSteps[step]}</p>
        ) : result ? (
          <>
            <h3>{result.title}</h3>
            <p>{result.description}</p>
            <p className="system-update-note">{result.note}</p>
          </>
        ) : <p>过去的频道已就绪，等你来接通。💾</p>}
      </Frame>
      <div className="system-diagnostic-actions">
        <Button onClick={checkUpdates} disabled={running}>
          {running ? '正在连接…' : checks ? '再次检查' : '检查更新'}
        </Button>
      </div>
    </div>
  );
}
